import React from 'react';
import { Popup } from 'react-map-gl/mapbox';

const ensureProtocol = (url) => {
  if (!url) return null;
  // If URL already has protocol, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Add https:// to URLs without protocol
  return `https://${url}`;
};

const EntryPopup = ({ location, entries, position, onClose }) => {
  if (!position) return null;

  return (
    <Popup
      longitude={position.longitude}
      latitude={position.latitude}
      anchor="bottom"
      onClose={onClose}
      closeOnClick={false}
      maxWidth="300px"
    >
      <div style={{ padding: '5px' }}>
        <h3 style={{ color: '#000000ff', margin: '0 0 10px 0', borderBottom: '1px solid #000000ff', paddingBottom: '5px' }}>
          {location}
        </h3>
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {entries.map(entry => (
            <div key={entry.id} style={{ marginBottom: '10px', padding: '5px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
              <h4 style={{ color: '#000000ff', margin: '0 0 5px 0', fontSize: '14px' }}>{entry.title}</h4>
              <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#666' }}>{entry.description}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '5px' }}>
                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#2c3e50' }}>{entry.price || 'Price N/A'}</span>
                {entry.url && (
                  <a href={ensureProtocol(entry.url)} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#3498db' }}>
                    View Link
                  </a>
                )}
              </div>
              <div style={{ fontSize: '10px', color: '#999', marginTop: '3px' }}>{entry.date}</div>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default EntryPopup;
